export const stringsKey = "MessageLanguageConfiguration";
export const englishStrings = {
	newMessageToolTip: "New Message",
	messageContentText: "Message Content in",
	rowDeleteConfirmationMessage:
		"Are you sure? All the details of selected row will be deleted on save.",
	columnDeleteConfirmationMessage:
		"Are you sure? All the details of selected column will be deleted on save.",
	whatsappMessageContentGuidelineMessage:
		"Make sure message follow the WhatsApp Business Policy to maintain Quality rating. It relies on user feedback to measure quality of messages. WhatsApp uses this feedback to track an internal quality rating for senders that can effect how users are able to move between rate limiting tiers. Senders with the Low quality rating may not be eligible to move up in rate limiting tiers.",
	messageContentToolTip:
		"To ensure that this WhatsApp message can be sent, please make sure that this message content is exactly the same as your submitted WhatsApp template",
};
